import axios from "axios";
import { API_URL } from "../config/config";
import { getHeaderOptions } from "./getHeaderOptions";
import Logger from "../utils/logger";
import logger from "../utils/logger";

const API_ENDPOINT = API_URL + "api/v1";

export const fetchTeamList = () => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.get(`${API_ENDPOINT}/team`, { headers: obj });
};

export const fetchOrganizationList = () => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.get(`${API_ENDPOINT}/organization`, { headers: obj });
};

export const getUserOrganizationList = (params: object) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  return axios.get(`${API_ENDPOINT}/user/employee`, {
    headers: obj,
    params: params,
  });
};

export const fetchDashboardLeadCount = (
  fromDate: string,
  toDate: string,
  organization: boolean,
  userId: string,
  selectedTeamId: string
) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  let finelUrl =
    organization && userId
      ? `&isOrganization=${organization}&userId=${userId}`
      : userId && selectedTeamId
      ? `&userId=${userId}&teams=${selectedTeamId}`
      : organization
      ? `&isOrganization=${organization}`
      : userId
      ? `&userId=${userId}`
      : selectedTeamId
      ? `&teams=${selectedTeamId}`
      : "";
  return axios.get(
    `${API_ENDPOINT}/dashboard/lead-count?fromDate=${fromDate}&toDate=${toDate}${finelUrl}`,
    { headers: obj }
  );
};

export const fetchDashboardAllActivityCount = (
  fromDate: string,
  toDate: string,
  organization: boolean,
  userId: string,
  selectedTeamId: string
) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  let finelUrl =
    organization && userId
      ? `&isOrganization=${organization}&userId=${userId}`
      : userId && selectedTeamId
      ? `&userId=${userId}&teams=${selectedTeamId}`
      : organization
      ? `&isOrganization=${organization}`
      : userId
      ? `&userId=${userId}`
      : selectedTeamId
      ? `&teams=${selectedTeamId}`
      : "";
  return axios.get(
    `${API_ENDPOINT}/dashboard/all-activities-count?fromDate=${fromDate}&toDate=${toDate}${finelUrl}`,
    { headers: obj }
  );
};

export const fetchDashboardSalesCount = (
  fromDate: string,
  toDate: string,
  organization: boolean,
  userId: string,
  selectedTeamId: string
) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  let finelUrl =
    organization && userId
      ? `&isOrganization=${organization}&userId=${userId}`
      : userId && selectedTeamId
      ? `&userId=${userId}&teams=${selectedTeamId}`
      : organization
      ? `&isOrganization=${organization}`
      : userId
      ? `&userId=${userId}`
      : selectedTeamId
      ? `&teams=${selectedTeamId}`
      : "";
  return axios.get(
    `${API_ENDPOINT}/dashboard/sales-value-count?fromDate=${fromDate}&toDate=${toDate}${finelUrl}`,
    { headers: obj }
  );
};

export const fetchDashboardGraphData = (
  fromDate: string,
  toDate: string,
  type: string,
  organization: boolean,
  userId: string,
  selectedTeamId: string
) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  let finelUrl =
    organization && userId
      ? `&isOrganization=${organization}&userId=${userId}`
      : userId && selectedTeamId
      ? `&userId=${userId}&teams=${selectedTeamId}`
      : organization
      ? `&isOrganization=${organization}`
      : userId
      ? `&userId=${userId}`
      : selectedTeamId
      ? `&teams=${selectedTeamId}`
      : "";
  return axios.get(
    `${API_URL}api/v2/dashboard/graph-data?fromDate=${fromDate}&toDate=${toDate}&dataType=${type}${finelUrl}`,
    { headers: obj }
  );
};

export const fetchDashboardLeadLableGraphData = (
  fromDate: string,
  toDate: string,
  organization: boolean,
  userId: string,
  selectedTeamId: string
) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  let finelUrl =
    organization && userId
      ? `&isOrganization=${organization}&userId=${userId}`
      : userId && selectedTeamId
      ? `&userId=${userId}&teams=${selectedTeamId}`
      : organization
      ? `&isOrganization=${organization}`
      : userId
      ? `&userId=${userId}`
      : selectedTeamId
      ? `&teams=${selectedTeamId}`
      : "";
  return axios.get(
    `${API_ENDPOINT}/dashboard/label-count?fromDate=${fromDate}&toDate=${toDate}${finelUrl}`,
    { headers: obj }
  );
};

export const fetchDashboardLeadSourceGraphData = (
  fromDate: string,
  toDate: string,
  organization: boolean,
  userId: string,
  selectedTeamId: string
) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  let finelUrl =
    organization && userId
      ? `&isOrganization=${organization}&userId=${userId}`
      : userId && selectedTeamId
      ? `&userId=${userId}&teams=${selectedTeamId}`
      : organization
      ? `&isOrganization=${organization}`
      : userId
      ? `&userId=${userId}`
      : selectedTeamId
      ? `&teams=${selectedTeamId}`
      : "";
  return axios.get(
    `${API_ENDPOINT}/dashboard/integration-count?fromDate=${fromDate}&toDate=${toDate}${finelUrl}`,
    { headers: obj }
  );
};

export const fetchDashboardFunnelChart = (
  fromDate: string,
  toDate: string,
  organization: boolean,
  userId: string,
  selectedTeamId: string
) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  let finelUrl =
    organization && userId
      ? `&isOrganization=${organization}&userId=${userId}`
      : userId && selectedTeamId
      ? `&userId=${userId}&teams=${selectedTeamId}`
      : organization
      ? `&isOrganization=${organization}`
      : userId
      ? `&userId=${userId}`
      : selectedTeamId
      ? `&teams=${selectedTeamId}`
      : "";
  return axios.get(
    `${API_ENDPOINT}/dashboard/status-count?fromDate=${fromDate}&toDate=${toDate}${finelUrl}`,
    { headers: obj }
  );
};

export const fetchDashboardTaskStatusChart = (
  fromDate: string,
  toDate: string,
  organization: boolean,
  userId: string,
  selectedTeamId: string
) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  let finelUrl =
    organization && userId
      ? `&isOrganization=${organization}&userId=${userId}`
      : userId && selectedTeamId
      ? `&userId=${userId}&teams=${selectedTeamId}`
      : organization
      ? `&isOrganization=${organization}`
      : userId
      ? `&userId=${userId}`
      : selectedTeamId
      ? `&teams=${selectedTeamId}`
      : "";
  return axios.get(
    `${API_ENDPOINT}/dashboard/all-task-count?fromDate=${fromDate}&toDate=${toDate}${finelUrl}`,
    {
      headers: obj,
    }
  );
};
export const fetchDashboardCallLeaderBoard = (
  fromDate: string,
  toDate: string,
  organization: boolean,
  userId: string,
  selectedTeamId: string
) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  let finelUrl =
    organization && userId
      ? `&isOrganization=${organization}&userId=${userId}`
      : userId && selectedTeamId
      ? `&userId=${userId}&teams=${selectedTeamId}`
      : organization
      ? `&isOrganization=${organization}`
      : userId
      ? `&userId=${userId}`
      : selectedTeamId
      ? `&teams=${selectedTeamId}`
      : "";
  return axios.get(
    `${API_ENDPOINT}/dashboard/call-leader-board?fromDate=${fromDate}&toDate=${toDate}${finelUrl}`,
    {
      headers: obj,
    }
  );
};
export const fetchDashboardQuotationStatusChart = (
  fromDate: string,
  toDate: string,
  organization: boolean,
  userId: string,
  selectedTeamId: string
) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  let finelUrl =
    organization && userId
      ? `&isOrganization=${organization}&userId=${userId}`
      : userId && selectedTeamId
      ? `&userId=${userId}&teams=${selectedTeamId}`
      : organization
      ? `&isOrganization=${organization}`
      : userId
      ? `&userId=${userId}`
      : selectedTeamId
      ? `&teams=${selectedTeamId}`
      : "";
  return axios.get(
    `${API_ENDPOINT}/dashboard/quotation-status-count?fromDate=${fromDate}&toDate=${toDate}${finelUrl}`,
    {
      headers: obj,
    }
  );
};

export const fetchDashboardMapcheckIn = (
  fromDate: string,
  toDate: string,
  organization: boolean,
  userId: string,
  selectedTeamId: string
) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  let finelUrl =
    organization && userId
      ? `&isOrganization=${organization}&userId=${userId}`
      : userId && selectedTeamId
      ? `&userId=${userId}&teams=${selectedTeamId}`
      : organization
      ? `&isOrganization=${organization}`
      : userId
      ? `&userId=${userId}`
      : selectedTeamId
      ? `&teams=${selectedTeamId}`
      : "";
  return axios.get(
    `${API_ENDPOINT}/dashboard/check-in?fromDate=${fromDate}&toDate=${toDate}${finelUrl}`,
    { headers: obj }
  );
};

export const fetchDashboardContentInfo = (
  fromDate: string,
  toDate: string,
  organization: boolean,
  userId: string,
  selectedTeamId: string
) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  let finelUrl =
    organization && userId
      ? `&isOrganization=${organization}&userId=${userId}`
      : userId && selectedTeamId
      ? `&userId=${userId}&teams=${selectedTeamId}`
      : organization
      ? `&isOrganization=${organization}`
      : userId
      ? `&userId=${userId}`
      : selectedTeamId
      ? `&teams=${selectedTeamId}`
      : "";
  return axios.get(
    `${API_ENDPOINT}/dashboard/content-count?fromDate=${fromDate}&toDate=${toDate}${finelUrl}`,
    { headers: obj }
  );
};
export const fetchSalesGoals = (
  fromDate: string,
  toDate: string,
  organization: boolean,
  userId: string,
  selectedTeamId: string
) => {
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  let finelUrl =
    organization && userId
      ? `&isOrganization=${organization}&userId=${userId}`
      : userId && selectedTeamId
      ? `&userId=${userId}&teams=${selectedTeamId}`
      : organization
      ? `&isOrganization=${organization}`
      : userId
      ? `&userId=${userId}`
      : selectedTeamId
      ? `&teams=${selectedTeamId}`
      : "";
  return axios.get(
    `${API_ENDPOINT}/dashboard/get-goal-target?fromDate=${fromDate}&toDate=${toDate}${finelUrl}`,
    { headers: obj }
  );
};

export const setUserTargets = async (
  userId: string,
  salesTarget: number | null | undefined,
  callsTarget: number | null | undefined
) => {
  try {
    Logger.log("Setting targets for user:", userId);
    Logger.log("Sales target:", salesTarget);
    Logger.log("Calls target:", callsTarget);

    const headers = {
      ...getHeaderOptions,
      Authorization: localStorage.getItem("auth_token") || "",
    };
    
    // Create the payload array
    const payload = [];
    
    // Add sales target if provided
    if (salesTarget !== null && salesTarget !== undefined) {
      payload.push({
        userId,
        type: "sales_amount",
        frequency: "monthly",
        target: Number(salesTarget)
      });
    }
    
    // Add calls target if provided
    if (callsTarget !== null && callsTarget !== undefined) {
      payload.push({
        userId,
        type: "calls",
        frequency: "monthly",
        target: Number(callsTarget)
      });
    }
    
    Logger.log("Sending target payload:", payload);
    
    // Make the API call
    const response = await axios.post(
      `${API_ENDPOINT}/user/set-goal`,
      payload,
      { headers }
    );
    
    Logger.log("Target setting response:", response);
    return response;
  } catch (error) {
    Logger.log("Error setting targets:", error);
    throw error;
  }
};




export const fetchDashboardLeadAssignmentDistribution = (
  fromDate: string,
  toDate: string,
  organization: boolean,
  userId: string,
  selectedTeamId: string
) => {
  // ✅ KEEP: Auth headers setup
  let obj = {
    ...getHeaderOptions,
    Authorization: localStorage.getItem("auth_token") || "",
  };
  
  // 🔄 TRANSFORMATION:
  const filterPrams = {
    isIgnoreList: true,
    date: {
      startedAt: fromDate,
      endedAt: toDate
    },
    ...(organization && { isOrganization: organization }),
    ...(userId && { userId }),
    ...(selectedTeamId && { teams: selectedTeamId })
  };

  logger.log('📡 Dashboard assignment API filterPrams:', filterPrams);

  // ✅ FIXED: Include headers with auth token
  return axios.post(
    `${API_ENDPOINT}/dashboard/lead-grouped-count`,
    {
      groupBy: "assignedTo",
      filterPrams: filterPrams
    },
    { headers: obj }  // ✅ CRITICAL: Auth headers!
  );
};